import { Brand } from './Brand';

export function LoadingScreen({ message = 'Preparando tu espacio...' }) {
  return (
    <main className="loading-screen">
      <Brand />
      <span className="spinner" aria-hidden="true" />
      <p>{message}</p>
    </main>
  );
}
